export default function TransactionsPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Transactions</h1>
      <p className="text-slate-500">Transactions list placeholder</p>
    </div>
  );
}
